export const contactsData = {
    email: 'sharmadeepankar0712@gmail.com',
    phone: '+919599880107',
    address: 'Gurgaon, Haryana',

    sheetAPI: ''
}